import { render, staticRenderFns } from "./TopControlItem.vue?vue&type=template&id=168984ff&scoped=true&"
import script from "./TopControlItem.vue?vue&type=script&lang=js&"
export * from "./TopControlItem.vue?vue&type=script&lang=js&"
import style0 from "./TopControlItem.vue?vue&type=style&index=0&id=168984ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168984ff",
  null
  
)

export default component.exports